module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-body",
    class: [_vm.finder]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns chartcontainer is-gapless"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h1', [_vm._v(_vm._s(this.client))]), _vm._v(" "), _c('h2', [_vm._v("Search Engine Optimization Results")]), _vm._v(" "), _c('div', {
    staticClass: "moreinfo"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "column is-8"
  }, [_c('div', {
    staticClass: "chart",
    class: [{
      'inview': _vm.inview
    }]
  }, [_c('v-waypoint', {
    staticClass: "chart--waypoint",
    on: {
      "waypoint-in": _vm.addInview,
      "waypoint-out": _vm.removeInview
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.chartdata), function(chartdataset, index) {
    return _c('li', {
      key: index,
      style: ({
        width: _vm.getWidth()
      })
    }, [_c('div', {
      key: index,
      class: _vm.getColor(index),
      style: ({
        height: _vm.getPct(chartdataset)
      }),
      attrs: {
        "title": _vm.formatMonth(index, chartdataset)
      },
      on: {
        "mouseover": _vm.barOver,
        "mouseleave": _vm.barOff
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "legend columns"
  }, [(this.initialmonth > -1) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "before"
  }), _vm._v(" "), _c('b', [_vm._v("Before Visible SEO Campaign")])]) : _vm._e(), _vm._v(" "), _vm._m(0)])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "after"
  }), _vm._v(" "), _c('b', [_vm._v("During Visible SEO Campaign")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21ccd01c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chart.vue
// module id = 108
// module chunks = 2